export default "__VITE_ASSET__CvefmsN2__"